<button class="warn transparent" mat-flat-button [class.waiting]="waiting" appStopPropagation (click)="cancelHold()">
  <ng-container *ngIf="!waiting"> {{ 'button.cancelHold' | translate }} </ng-container>

  <mat-spinner *ngIf="waiting" [diameter]="20"></mat-spinner>
</button>
